import { ImageLite } from "shared/components";

import styles from "./SingleImage.module.scss";

export const SingleImage = ({ images }) => {
  const [singleImage] = images;
  return <ImageLite image={singleImage} className={styles.image} />;
};
